import React, { useState } from 'react';
import emailjs from '@emailjs/browser';

const ContactForm = ({ preset }) => {
  const [form, setForm] = useState({
    name: '',
    email: '',
    telephone: '',
    title: preset?.title || '',
    message: preset?.message || ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      // EmailJS configuration - you'll need to set these up
      await emailjs.send(
        "service_rbivfm1",
        "template_ciiclpw",
        {
          from_name: form.name,
          from_email: form.email,
          phone: form.telephone,
          subject: form.title,
          message: form.message
        },
        '0cTfF0c8VMVqWfDWV' // Replace with your EmailJS public key
      );

      setSubmitStatus('success');
      setForm({
        name: '',
        email: '',
        telephone: '',
        title: '',
        message: ''
      });
    } catch (error) {
      console.error('Email send error:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form className="card" onSubmit={handleSubmit} style={{ display: 'grid', gap: 12 }}>
      <div style={{ display: 'grid', gap: 8 }}>
        <label>Nom / Société</label>
        <input 
          className="input" 
          name="name" 
          value={form.name} 
          onChange={handleChange} 
          required 
          disabled={isSubmitting}
        />
      </div>
      <div className="grid" style={{ gridTemplateColumns: '1fr 1fr' }}>
        <div>
          <label>Email</label>
          <input 
            className="input" 
            type="email" 
            name="email" 
            value={form.email} 
            onChange={handleChange} 
            required 
            disabled={isSubmitting}
          />
        </div>
        <div>
          <label>Téléphone / WhatsApp</label>
          <input 
            className="input" 
            name="telephone" 
            value={form.telephone} 
            onChange={handleChange} 
            disabled={isSubmitting}
          />
        </div>
      </div>
      <div>
        <label>Sujet</label>
        <input 
          className="input" 
          name="title" 
          value={form.title} 
          onChange={handleChange} 
          disabled={isSubmitting}
        />
      </div>
      <div>
        <label>Message</label>
        <textarea 
          className="textarea" 
          rows="5" 
          name="message" 
          value={form.message} 
          onChange={handleChange} 
          disabled={isSubmitting}
        />
      </div>
      
      <button 
        className="btn" 
        type="submit" 
        disabled={isSubmitting}
        style={{ 
          opacity: isSubmitting ? 0.6 : 1,
          cursor: isSubmitting ? 'not-allowed' : 'pointer'
        }}
      >
        {isSubmitting ? 'Envoi en cours...' : 'Envoyer'}
      </button>

      {submitStatus === 'success' && (
        <p style={{ color: '#10b981', fontSize: 14 }}>
          ✅ Message envoyé avec succès !
        </p>
      )}
      
      {submitStatus === 'error' && (
        <p style={{ color: '#ef4444', fontSize: 14 }}>
          ❌ Erreur lors de l'envoi. Veuillez réessayer.
        </p>
      )}
    </form>
  );
};

export default ContactForm;